import { useEffect, useMemo, useState } from "react";
import useDataStore from "../../../stores/dataStore";
import useMainStore from "../../../stores/mainStore";
import Note from "./note/note";
import useTextFilesStore from "../../../stores/textFilesStore";

function NotesContainer() {
    // Update when number of notes changes or sortNotesBy changes
    const filterString = useMainStore((state) => state.data.filterString);
    const Notes = useDataStore((state) => state.data?.notes);
    const sortNotesBy = useMainStore((state) => state.data.sortNotesBy);
    const [sortedNotes, setSortedNotes] = useState<string[]>([]);
    const sortNotesNewToOld = useMainStore(
        (state) => state.data.sortNotesNewToOld
    );

    const selectedFolderID = useMainStore(
        (state) => state.data.selectedFolderID
    );

    // If the order of notes changes, update sortedNotes
    useEffect(() => {
        const sortedNotes_ = GetSortedList(
            sortNotesBy,
            Notes,
            filterString,
            selectedFolderID
        );

        if (sortNotesNewToOld) {
            sortedNotes_.reverse();
        }

        if (JSON.stringify(sortedNotes_) !== JSON.stringify(sortedNotes)) {
            setSortedNotes(sortedNotes_);
        }
    }, [Notes, sortNotesBy, sortNotesNewToOld, filterString, selectedFolderID]);

    // Using useMemo to prevent rerendering. The order of notes will only change if the stringified version of sortedNotes changes
    const memoizedNotesContainer = useMemo(() => {
        if (!Notes) return null;
        return (
            <div className="flex-1  mx-2 flex flex-col">
                {sortedNotes.map((id, index) => (
                    <Note key={id} id={id} />
                ))}
            </div>
        );
    }, [sortedNotes]);

    return memoizedNotesContainer;
}
export default NotesContainer;

// Sort the notes by the selected option
function GetSortedList(
    sortNotesBy: "Date Created" | "Date Updated" | "Title",
    Notes: { [id: string]: Note },
    filterText: string = "",
    selectedFolderID: string | undefined
): string[] {
    let notes = Object.values(Notes);
    let sortedList: Note[] = [];

    if (filterText) {
        notes = notes.filter(
            (note) =>
                note.title.toLowerCase().includes(filterText.toLowerCase()) ||
                useTextFilesStore
                    .getState()
                    .textFiles[note.id]?.content.toLowerCase()
                    .includes(filterText.toLowerCase())
        );
    }

    // Make sure notes have an id
    notes = notes.filter((note) => note.id);

    // Only show notes in selected folder
    notes = notes.filter((note) => {
        if (!note.folderID && selectedFolderID === "uncategorized") return true;
        if (note.folderID === selectedFolderID) return true;
        return false;
    });

    switch (sortNotesBy) {
        case "Date Created":
            sortedList = notes.sort((a, b) => {
                return (
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                );
            });
            break;

        case "Date Updated":
            sortedList = notes.sort((a, b) => {
                return (
                    new Date(b.updatedAt).getTime() -
                    new Date(a.updatedAt).getTime()
                );
            });
            break;

        case "Title":
            sortedList = notes.sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
            break;
        default:
            break;
    }
    return sortedList.map((note) => note.id);
}
